module.exports = __webpack_public_path__ + "static/media/background_pattern_opaque.88a8225a.svg";